import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    modal: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 1000,
      width: "688px",
      maxWidth: "calc(100% - 32px)",
      maxHeight: "calc(100vh - 32px)",
      borderRadius: "12px",
      background: theme.palette.background.paper,
      boxShadow:
        "0px 8px 24px -4px rgba(16, 24, 40, 0.15), 0px 8px 16px -4px rgba(16, 24, 40, 0.10)",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        maxWidth: "100%",
        maxHeight: "100vh",
        borderRadius: 0,
        top: 0,
        left: 0,
        transform: "none",
      },
    },
    header: {
      padding: "24px 24px 0px 24px",
      display: "flex",
      flexDirection: "column",
    },
    middleSection: {
      padding: "0px 24px",
    },
    searchBox: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "8px",
      maxWidth: "98%",
      "& > *:nth-child(1)": {
        width: "fit-content !important",
        maxWidth: "fit-content !important",
      },
    },
    customInputContainer: {
      width: "320px !important",
      maxWidth: "320px !important",
      [theme.breakpoints.down("sm")]: {
        width: "100% !important",
      },
    },
    wrapperContent: {
      padding: "20px 24px",
      overflowY: "auto",
      [theme.breakpoints.down("sm")]: {
        padding: "12px 4px",
        maxHeight: "calc(100vh - 220px)",
      },
    },
    card: {
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column !important",
        alignItems: "flex-start !important",
        gap: "12px !important",
      },
    },
    mainTitle: {
      fontSize: "18px",
      fontWeight: 600,
      color: theme.palette.text.primary,
      lineHeight: "28px",
    },
    subTitle: {
      fontSize: "14px",
      fontWeight: 400,
      color: theme.palette.text.tertiary,
      lineHeight: "20px",
    },
    cardText: {
      fontSize: "16px",
      fontWeight: 400,
      color: theme.palette.text.text_quarterary,
    },
    footerActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "24px",
      [theme.breakpoints.down("sm")]: {
        marginBottom: "80px",
      },
    },
  };
});
